import type { Game } from 'chessboard/model/game/types';
import type { Markings } from 'chessboard/plugins/markings/config/types';

export namespace Highlights {
  export namespace Plugin {
    export const Name = 'highlights';
  }
}

export interface API<T extends any[]> {
  addModule: (module: HighlightsModule<T>, index?: number | undefined) => void;
  getModules: () => HighlightsModule<T>[];
  removeModule: (module: HighlightsModule<T>) => void;
  getAll(): KeyedHighlight[];
  update(...params: T): HighlightChanges;
  clearState(): void;
}

export type BlinkingHighlightData = HighlightData & {
  interval: number;
  times: number;
};

export type BlinkingHighlightParams = {
  data: BlinkingHighlightData;
  type: typeof HighlightType;
};

export type Highlight = Markings.Model & HighlightParams;

export interface HighlightChanges {
  toAdd: KeyedHighlight[];
  toRemove: KeyedHighlight[];
}

export type HighlightData = Markings.WithColor &
  Markings.WithOpacity &
  Markings.WithSquare & {
    turn?: Game.ColorsAsNumbers;
    type?: string;
  };

export type HighlightParams = {
  data: HighlightData;
  type: typeof HighlightType;
};

export type HighlightsModule<T extends any[]> = (...params: T) => KeyedHighlight[];

export type KeyedBlinkingHighlight = Markings.KeyedModel & BlinkingHighlightParams;

export type KeyedHighlight = Markings.KeyedModel & HighlightParams;

export const HighlightType = 'highlight';
